import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';
import { palette } from '@shared/tokens/palette.stylex';

export const styles = stylex.create({
  container: {
    background: palette['grey-50'],
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: {
      default: '64px 0 0',
      '@media (max-width: 767px)': ' 32px 16px',
    },
    minHeight: '100vh',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
  },
  content: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '40px 0',
  },
});
